const INITIAL_STATE = {
  loading: false,
  featureDisabled: false,
  list: { items: [], total: 0, page: 1, limit: 20 },
  inviteLoading: false,
  inviteError: null,
  revokeLoading: false,
  eligibleDependents: {
    loading: false,
    items: [],
    error: null,
  },
  accept: {
    loading: false,
    meta: null,
    error: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GUESTS_LOAD':
      return { ...state, loading: action.payload };
    case 'GUESTS_FETCHED':
      return {
        ...state,
        list: action.payload,
        loading: false,
        featureDisabled: false,
      };
    case 'GUESTS_FEATURE_DISABLED':
      return {
        ...state,
        loading: false,
        featureDisabled: true,
        list: INITIAL_STATE.list,
      };
    case 'GUESTS_INVITE_LOAD':
      return { ...state, inviteLoading: action.payload };
    case 'GUESTS_INVITE_ERROR':
      return { ...state, inviteError: action.payload };
    case 'GUESTS_REVOKE_LOAD':
      return { ...state, revokeLoading: action.payload };
    case 'GUESTS_DEPENDENTS_LOAD':
      return {
        ...state,
        eligibleDependents: {
          ...state.eligibleDependents,
          loading: action.payload,
        },
      };
    case 'GUESTS_DEPENDENTS_FETCHED':
      return {
        ...state,
        eligibleDependents: {
          loading: false,
          items: action.payload || [],
          error: null,
        },
      };
    case 'GUESTS_DEPENDENTS_ERROR':
      return {
        ...state,
        eligibleDependents: {
          ...state.eligibleDependents,
          loading: false,
          error: action.payload,
        },
      };
    case 'GUESTS_ACCEPT_LOAD':
      return { ...state, accept: { ...state.accept, loading: action.payload } };
    case 'GUESTS_ACCEPT_META':
      return {
        ...state,
        accept: { ...state.accept, meta: action.payload, error: null },
      };
    case 'GUESTS_ACCEPT_ERROR':
      return { ...state, accept: { ...state.accept, error: action.payload } };
    case 'GUESTS_ACCEPT_RESET':
      return { ...state, accept: INITIAL_STATE.accept };
    default:
      return state;
  }
};
